import { isAddressInSharedFeatureAllowlist } from '@ui/constants/allowlist';

export const isAddressInShowProtocolPNL = (
  address?: string | null,
): boolean => {
  return isAddressInSharedFeatureAllowlist(address);
};

export const isAddressInOneClickAllowlist = (
  address?: string | null,
): boolean => {
  if (!address) return false;

  return true;
  // return ONE_CLICK_TRADING_ALLOWLIST.has(address.toLowerCase());
};

export const isAddressInSwap = (address?: string | null): boolean => {
  return true;
};